import { BrowserRouter, Route, Routes } from "react-router-dom";
import useInactivityLogout from "../src/hook/useInactivityLogout"; // Adjust path
import RouteScrollToTop from "./helper/RouteScrollToTop";
import React, { useState } from "react";
// All page imports (unchanged)
import HomePageOne from "./pages/Auth/HomePageOne";
import SubadminPage from "./pages/SubAdmin/SubAdminListPage";
import AddSubadminPage from "./pages/SubAdmin/AddSubAdminPage";
import EditSubadminPage from "./pages/SubAdmin/EditSubadminPage";
import ViewSubadminPage from "./pages/SubAdmin/ViewSubadminPage";
import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/Auth/SignInPage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import OTPPage from "./pages/Auth/OTPPage";
import ResetPasswordPage from "./pages/Auth/ResetPassword";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import FAQPage from "./pages/FAQ/FAQList";
import AddFAQPage from "./pages/FAQ/AddFAQPage";
import EditFAQPage from "./pages/FAQ/EditFAQPage";
import ViewFAQPage from "./pages/FAQ/ViewFAQPage";
import CMSPage from "./pages/CMS/CMSList";
import EditCMSPage from "./pages/CMS/EditCMSPage";
import ViewCMSPage from "./pages/CMS/ViewCMSPage";
import ViewProfilePage from "./pages/Auth/ViewProfilePage";
import SendNotification from "./pages/notification/AddNotification";
import Notification from "./pages/notification/NotificationList";
import DengerAlert from "../src/components/child/Alert/DengerAlert";
import UserList from "./pages/User/UserList";
import ChurnRiskPage from "./pages/ChurnRiskPage";
import PossibleDuplicatesPage from "./pages/PossibleDuplicatesPage";
import DownloadHitsPage from "./pages/DownloadHitsPage";
import SurveysPage from "./pages/SurveysPage";
import GiveawaysPage from "./pages/Giveaways/GiveawaysPage";
import GiveawayDetailPage from "./pages/Giveaways/GiveawayDetailPage";
import ViewUserPage from "./pages/User/ViewUserPage";
import EditUserPage from "./pages/User/EditUserPage";
import VaultQuestionsList from "./pages/VaultQuestions/VaultQuestionsList";
import AddVaultQuestionsPage from "./pages/VaultQuestions/AddVaultQuestionsPage";
import EditVaultQuestionsPage from "./pages/VaultQuestions/EditVaultQuestionsPage";
import ViewVaultQuestionsPage from "./pages/VaultQuestions/ViewVaultQuestionsPage";
import "./App.css";
import AddEditBulkVaultQuestionsPage from "./pages/VaultQuestions/AddEditBulkVaultQuestionsPage";
import DynamicFieldListPage from "./pages/DynamicField/DynamicFieldListPage";
import ViewDynamicFieldPage from "./pages/DynamicField/ViewDynamicFieldPage";
import EditDynamicFieldPage from "./pages/DynamicField/EditDynamicFieldPage";
import AddDynamicFieldPage from "./pages/DynamicField/AddDynamicFieldPage";
import DiscoveryConfigListPage from "./pages/DiscoveryConfig/DiscoveryConfigListPage";
import ViewDiscoveryConfigPage from "./pages/DiscoveryConfig/ViewDiscoveryConfigPage";
import AddDiscoveryConfigPage from "./pages/DiscoveryConfig/AddDiscoveryConfigPage";
import EditDiscoveryConfigPage from "./pages/DiscoveryConfig/EditDiscoveryConfigPage";
import MatchList from "./pages/MatchAndDiscoveryControl/MatchList";
import EditMatchPage from "./pages/MatchAndDiscoveryControl/EditMatchPage";
import ViewMatchPage from "./pages/MatchAndDiscoveryControl/ViewMatchPage";
import CompatibilityList from "./pages/CompatibilityControl/CompatibilityList";
import ViewCompatibilityPage from "./pages/CompatibilityControl/ViewCompatibilityPage";
import EditCompatibilityPage from "./pages/CompatibilityControl/EditCompatibilityPage";
import AuditHistoryList from "./pages/Audit History/AuditHistoryListPage";
import ViewAuditHistoryPage from "./pages/Audit History/ViewAuditHistoryPage";
import MyNotificationList from "./pages/Admin Notification/AdminNotificationList";
import ViewReceivedNotification from "./pages/Admin Notification/ViewReceivedNotification";
import ViewSendNotification from "./pages/notification/ViewSendNotification";
import UserReportList from "./pages/UserReport/UserReportList";
import ViewUserReport from "./pages/UserReport/ViewUserReport";
import EditNotification from "./pages/notification/EditNotification";
import FeatureRequestList from "./pages/Feature Request/FeatureRequestList";
import ViewFeatureRequest from "./pages/Feature Request/ViewFeatureRequest";
import UpdateFeatureRequest from "./pages/Feature Request/UpdateFeatureRequest";
import AnalyticsAndReporting from "./pages/AnalyticsAndReporting/AnalyticsAndReporting";
import TransactionsList from "./pages/Transactions Page/TransactionsList";
import ViewTransactionPage from "./pages/Transactions Page/ViewTransactionPage";
import SubscriptionsPage from "./pages/SubscriptionPage/SubscriptionsPage";
import ViewSubscriptionsPage from "./pages/SubscriptionPage/ViewSubscriptionsPage";
import HelpAndSupportPage from "./pages/HelpAndSupport/HelpAndSupportPage";
import ViewHelpAndSupportPage from "./pages/HelpAndSupport/ViewHelpAndSupportPage";
import Chat from "./pages/Chat/Chat";
import AdminSettingLayer from "./components/AdminSetting/AdminSettingLayer";
import AdminSettingPage from "./pages/AdminSetting/AdminSettingPage";
import EventsList from "./pages/Events/EventsList";
import AddEditEvent from "./pages/Events/AddEditEvent";

// ✅ This is the component that includes useInactivityLogout (inside <BrowserRouter>)
function AppContent() {
  const [alertMessage, setAlertMessage] = useState(null);

  // Pass the alert function to the hook
  useInactivityLogout((message) => {
    setAlertMessage(message); // Set alert message
  });

  return (
    <>
      <RouteScrollToTop />
      {alertMessage && (
        <DengerAlert
          message={alertMessage}
          onClose={() => setAlertMessage(null)} 
        />
      )}
      <Routes>
        {/* Auth */}
        <Route exact path="/" element={<SignInPage />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/forgotpassword" element={<ForgotPasswordPage />} />
        <Route exact path="/otpverify" element={<OTPPage />} />
        <Route exact path="/resetpassword" element={<ResetPasswordPage />} />
        <Route exact path="/dashboard" element={<HomePageOne />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        {/******** Sub Admin ***** */}
        <Route exact path="/subadmin" element={<SubadminPage />} />
        <Route
          exact
          path="/subadmin/add-Subadmin"
          element={<AddSubadminPage />}
        />
        <Route
          exact
          path="/subadmin/edit-Subadmin/:id?"
          element={<EditSubadminPage />}
        />
        <Route
          exact
          path="/subadmin/view-Subadmin/:id?"
          element={<ViewSubadminPage />}
        />
        {/******** FAQ ***** */}
        <Route exact path="/faq" element={<FAQPage />} />
        <Route exact path="/faq/add-faq" element={<AddFAQPage />} />
        <Route exact path="/faq/edit-faq/:id?" element={<EditFAQPage />} />
        <Route exact path="/faq/view-faq/:id?" element={<ViewFAQPage />} />
        {/******** CMS ***** */}
        <Route exact path="/cms" element={<CMSPage />} />
        <Route exact path="/cms/edit-cms/:id?" element={<EditCMSPage />} />
        <Route exact path="/cms/view-cms/:id?" element={<ViewCMSPage />} />
        {/******** USER ***** */}
        <Route exact path="/user" element={<UserList />} />
        <Route exact path="/silent-churn" element={<ChurnRiskPage />} />
        <Route exact path="/possible-duplicates" element={<PossibleDuplicatesPage />} />
        <Route exact path="/curiouzz-qr" element={<DownloadHitsPage />} />
        <Route exact path="/user/view-user/:id?" element={<ViewUserPage />} />
        <Route exact path="/user/edit-user/:id?" element={<EditUserPage />} />
        {/******** vaultQuestions ***** */}
        <Route exact path="/vault-questions" element={<VaultQuestionsList />} />
        <Route
          exact
          path="/vault-questions/add-vault-question"
          element={<AddVaultQuestionsPage />}
        />
        <Route
          exact
          path="/vault-questions/edit-vault-question/:id?"
          element={<EditVaultQuestionsPage />}
        />
        <Route
          exact
          path="/vault-questions/view-vault-question/:id?"
          element={<ViewVaultQuestionsPage />}
        />
        <Route
          path="/vault-questions/bulk-edit"
          element={<AddEditBulkVaultQuestionsPage />}
        />
        {/******** Preferences ***** */}
        <Route exact path="/preferences" element={<DynamicFieldListPage />} />
        <Route
          exact
          path="/preferences/view/:id"
          element={<ViewDynamicFieldPage />}
        />
        <Route
          exact
          path="/preferences/add"
          element={<AddDynamicFieldPage />}
        />
        <Route
          exact
          path="/preferences/edit/:id"
          element={<EditDynamicFieldPage />}
        />
        {/******** Compatibility Algorithm ***** */}
        <Route
          exact
          path="/discovery-config"
          element={<DiscoveryConfigListPage />}
        />
        <Route
          exact
          path="/discovery-config/view-discovery-config/:id"
          element={<ViewDiscoveryConfigPage />}
        />
        <Route
          exact
          path="/discovery-config/add-discovery-config"
          element={<AddDiscoveryConfigPage />}
        />
        <Route
          exact
          path="/discovery-config/edit-discovery-config/:id"
          element={<EditDiscoveryConfigPage />}
        />
        <Route exact path="/match-control" element={<MatchList />} />
        <Route exact path="/compatibility-control" element={<CompatibilityList />} />
        <Route
          exact
          path="/compatibility-control/edit/:id"
          element={<EditCompatibilityPage />}
        />
        <Route
          exact
          path="/compatibility-control/view/:id"
          element={<ViewCompatibilityPage />}
        />
        <Route
          exact
          path="/match-control/edit/:id"
          element={<EditMatchPage />}
        />
        <Route
          exact
          path="/match-control/view/:id"
          element={<ViewMatchPage />}
        />
        <Route exact path="/audit-history" element={<AuditHistoryList />} />
        <Route
          exact
          path="/audit-history/view/:id"
          element={<ViewAuditHistoryPage />}
        />

        {/* User Report */}
        <Route exact path="/user-report" element={<UserReportList />} />
        <Route exact path="/user-report/view/:id" element={<ViewUserReport />} />



        {/******** Notification ***** */}
        <Route exact path="/notification" element={<Notification />} />
        <Route exact path="/notification/sent" element={<SendNotification />} />
        <Route
          path="/notification/view/sent/:id"
          element={<ViewSendNotification />}
        />
        <Route path="/notification/edit/:id" element={<EditNotification />} />


        <Route exact path="/mynotification" element={<MyNotificationList />} />
        <Route
          path="/mynotification/view/received/:id"
          element={<ViewReceivedNotification />}
        />

        <Route exact path="/feature-requests" element={<FeatureRequestList />} />
        <Route exact path="/surveys" element={<SurveysPage />} />
        {/* Giveaways (2026-10-22): super admins only */}
        <Route exact path="/giveaways" element={<GiveawaysPage />} />
        <Route exact path="/giveaways/:id" element={<GiveawayDetailPage />} />
        <Route
          exact
          path="/feature-request/view/:id"
          element={<ViewFeatureRequest />}
        />
        <Route path="/feature-request/edit/:id" element={<UpdateFeatureRequest />} />

        <Route exact path="/analytics-reporting" element={<AnalyticsAndReporting />} />

        <Route exact path="/payments-transactions" element={<TransactionsList />} />
        <Route path="/payments-transactions/view/:id" element={<ViewTransactionPage />} />

        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/subscriptions/view/:id" element={<ViewSubscriptionsPage />} />

        <Route path="/help-supports" element={< HelpAndSupportPage />} />
        <Route path="/help-support/view/:id" element={<ViewHelpAndSupportPage />} />

        <Route exact path="/chat" element={<Chat />} />



        <Route exact path="/admin-settings" element={<AdminSettingPage />} />

        {/* Density Part 4 — Events CMS */}
        <Route exact path="/events" element={<EventsList />} />
        <Route exact path="/events/add" element={<AddEditEvent />} />
        <Route exact path="/events/edit/:id" element={<AddEditEvent />} />


        {/* *********** Extra PAges ************ */}
        <Route exact path="/coming-soon" element={<ComingSoonPage />} />
        <Route exact path="/access-denied" element={<AccessDeniedPage />} />
        <Route exact path="/maintenance" element={<MaintenancePage />} />
        <Route exact path="/blank-page" element={<BlankPagePage />} />
        {/* <Route exact path='*' element={<ErrorPage />} /> */}
        <Route exact path="*" element={<ComingSoonPage />} />
      </Routes>
    </>
  );
}

// ✅ Main app entry that wraps everything in <BrowserRouter>
function App() {
  return (
    <BrowserRouter
      // basename="curioizz-admin"
    >
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
